import { useState, useEffect, } from "react";
import { useContext,} from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./NaphthaReflux.css";
import { WellContext } from "../context/WellContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import LaboratoryAnalysisFaceplate from "../components/LaboratoryAnalysisFaceplate";
import { crudeDatabase } from "../data/crudeDatabase";




import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function NaphthaReflux() {

    useEffect(() => {
    
      trackPageVisit("NaphthaReflux");
    
    }, []);
  
     const {toggleValve, valves} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);
  const [showLab,setShowLab] = useState(false); 
  const [showLabFaceplate, setShowLabFaceplate] = useState(false);

  const DEFAULT_VALVES = {
  FCV_2601: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2602: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2603: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("NaphthaReflux_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2601: { ...DEFAULT_VALVES.FCV_2601, ...parsed.FCV_2601 },
      FCV_2602: { ...DEFAULT_VALVES.FCV_2602, ...parsed.FCV_2602 },
      FCV_2603: { ...DEFAULT_VALVES.FCV_2603, ...parsed.FCV_2603 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("NaphthaReflux_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};






const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF FLASHED HYDROCARBONS FROM T-101 =================

const PreFlashOverheadComposition =
  JSON.parse(
    localStorage.getItem(
      "PreFlashOverheadComposition"
    )
  ) || {};

const PreFlashOverheadFlow =
  Number(
    localStorage.getItem(
      "PreFlashOverheadFlow"
    )
  ) || 0;



  
  const FIC_2206 =
  Number(
    localStorage.getItem(
      "FIC_2206"
    )
  ) || 0;


  
  const TT_2503 =
  Number(
    localStorage.getItem(
      "TT_2503"
    )
  ) || 0;

  
  const PT_2502 =
  Number(
    localStorage.getItem(
      "PT_2502"
    )
  ) || 0;

  const FCV2201 =
  Number(
    localStorage.getItem(
      "FCV2201"
    )
  ) || 0;



  const LightNaphthaOverhead =
  PreFlashOverheadFlow *
  (
    PreFlashOverheadComposition.LightNaphtha || 0
  ) / 100;

const HeavyNaphthaOverhead =
  PreFlashOverheadFlow *
  (
    PreFlashOverheadComposition.HeavyNaphtha || 0
  ) / 100;

const KeroseneOverhead =
  PreFlashOverheadFlow *
  (
    PreFlashOverheadComposition.Kerosene || 0
  ) / 100;


const flashedComposition =
  JSON.parse(
    localStorage.getItem("OverheadComposition")
  ) || {};


  const totalOverhead =

(flashedComposition?.LightNaphthaFeed || 0) +
(flashedComposition?.HeavyNaphthaFeed || 0) +
(flashedComposition?.KeroseneFeed || 0) +
(flashedComposition?.DieselFeed || 0) +
(flashedComposition?.VGOFeed || 0) +
(flashedComposition?.ResidueFeed || 0);



const lightNaphthaPct =
((flashedComposition?.LightNaphthaFeed || 0)
 / totalOverhead) * 100;

const heavyNaphthaPct =
((flashedComposition?.HeavyNaphthaFeed || 0)
 / totalOverhead) * 100;

const kerosenePct =
((flashedComposition?.KeroseneFeed || 0)
 / totalOverhead) * 100;

const dieselPct =
((flashedComposition?.DieselFeed || 0)
 / totalOverhead) * 100;

const vgoPct =
((flashedComposition?.VGOFeed || 0)
 / totalOverhead) * 100;

const residuePct =
((flashedComposition?.ResidueFeed || 0)
 / totalOverhead) * 100;


 const selectedCrude =
localStorage.getItem(
"MDS_selectedCrude"
);

const crude =
crudeDatabase[selectedCrude];



const IBP =
crude?.tbpDistillation?.[70]?.value || 0;

const TBP10 =
crude?.tbpDistillation?.[72]?.value || 0;

const TBP20 =
crude?.tbpDistillation?.[73]?.value || 0;

const TBP30 =
crude?.tbpDistillation?.[74]?.value || 0;

const TBP40 =
crude?.tbpDistillation?.[75]?.value || 0;

const TBP50 =
crude?.tbpDistillation?.[76]?.value || 0;

const FBP =
crude?.tbpDistillation?.[82]?.value || 0;



const openLabAnalysis = () => {
   console.log("LAB REPORT CLICKED");
  localStorage.setItem(
  "CurrentLabSample",
  JSON.stringify({
    source: "NaphthaReflux",
    crude: localStorage.getItem("MDS_selectedCrude"),
    composition: flashedComposition,
    sampleDate: new Date().toISOString()
  })
);
  setShowLabFaceplate(true);
};

// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
            const { transmitters, flowOverrides } = usePlantStore();
            const TT_17003 = transmitters.TT_17003 || 0;
            const PT_17002 = transmitters.PT_17002 || 0;
            const FIC_17001 = transmitters.FIC_17001 || 0;
            const NaphthaRefluxFCV = transmitters.NaphthaRefluxFCV || 0;
  
const VaporIn =
  Number(
    localStorage.getItem(
      "PreFlashOverheadFlow"
    )
  ) || 0;




    const xv2601Open = !valves?.XV_2601;
    const xv2602Open = !valves?.XV_2602;
    const xv2603Open = !valves?.XV_2603;
    const xv2604Open = !valves?.XV_2604;
    const xv2605Open = !valves?.XV_2605;


  
  
// BACKPRESSURE EFFECT AS A RESULT OF GAS OUTLET VALVE CLOSURE

    let BackPressureFactor = 0;

    if (
      !xv2604Open &&
      VaporIn > 0.1
    )
    {
      BackPressureFactor =
        Math.min(
          1.5,
          VaporIn * 0.05
        );
    }

    localStorage.setItem(
        "BackPressureFactor",
        BackPressureFactor
      );



    const FIC_2601 = FIC_2206;
    const TT_2601 = TT_2503;
    const PT_2601 = PT_2502 + (BackPressureFactor * 0.80);
    
    const FIC_26011 = xv2603Open ? 0.435 : 0;




/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};


/* =========================================================
   P-104A / B STATUS
========================================================= */

const P104A_Running =
  pumpData?.["P-104A"]?.running ?? false;

const P104B_Running =
  pumpData?.["P-104B"]?.running ?? false;

const P104_Running =
  P104A_Running || P104B_Running;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P104_CAPACITY = 6.456;


/* =========================================================
   FCV OPENINGS
========================================================= */

const FCV2601_Opening =
  (valveData?.FCV_2601?.opening || 0) / 100;

const FCV2604_Opening = NaphthaRefluxFCV;


/* =========================================================
   TOTAL OPENING
========================================================= */

const totalOpening =
  FCV2601_Opening +
  FCV2604_Opening;


/* =========================================================
   PUMP UTILIZATION
========================================================= */

const PumpUtilization =
  Math.min(totalOpening, 1);


/* =========================================================
   AVAILABLE PUMP FLOW
========================================================= */

const PumpAvailableFlow =
  P104_Running
    ? P104_CAPACITY * PumpUtilization
    : 0;


/* =========================================================
   TARGET FLOWS
========================================================= */

const targetFIC_2604 =
  totalOpening > 0
    ? PumpAvailableFlow *
      (FCV2601_Opening / totalOpening)
    : 0;


const targetFIC_2605 =
  totalOpening > 0
    ? PumpAvailableFlow *
      (FCV2201 / totalOpening)
    : 0;


/* =========================================================
   FIC-2604 (TO TANK)
========================================================= */

const FIC_2604 = flowOverrides?.FIC_2606 ? 0 :
  (processData.FIC_2604 || 0);

useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_2604 || 0);

      const target =
        Number(targetFIC_2604 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_2604: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_2604]);

/* =========================================================
   FIC-2605 (REFLUX)
========================================================= */

const FIC_2605 = flowOverrides?.FIC_2606 ? 0 :
  (processData.FIC_2605 || 0);

useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_2605 || 0);

      const target =
        Number(targetFIC_2605 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_2605: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_2605]);

/* =========================================================
   TOTAL PUMP FLOW
========================================================= */

const FIC_2606 =
  Number(
    (
      FIC_2604 +
      FIC_2605
    ).toFixed(3)
  );

useEffect(() => {

  setProcessData(prev => {

    if (prev.FIC_2606 === FIC_2606) {
      return prev;
    }

    return {
      ...prev,
      FIC_2606
    };

  });

}, [FIC_2606]);

/* =========================================================
   DISCHARGE PRESSURE
========================================================= */

const PT_2602 =
  P104_Running &&
  totalOpening > 0
    ? 0.983
    : 0.03;


/* =========================================================
   DISCHARGE TEMPERATURE
========================================================= */

const TT_2602 =
  P104_Running
    ? Number(TT_2601 || 25)
    : 25;





    
/* =========================================================
              SPLITTING MAIN LINE OF P-104A/B
========================================================= */

const PreFlashedNaphthaSplit =
[
  xv2601Open,
  xv2602Open
  ].filter(Boolean).length;

const FIC_2607 =
  xv2601Open
    ? FIC_2604 / PreFlashedNaphthaSplit
    : 0;

const FIC_2608 =
  xv2602Open
    ? FIC_2604 / PreFlashedNaphthaSplit
    : 0;



const PT_2607 = xv2601Open ? PT_2602 : 0.03;
const TT_2607 = xv2601Open ? TT_2602 : 32;

const PT_2608 = xv2602Open ? PT_2602 : 0.03;
const TT_2608 = xv2602Open ? TT_2602 : 32;






/* =========================================================
   P-110 STATUS
========================================================= */

const P110_Running =
  pumpData?.["P-110"]?.running ?? false;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P110_CAPACITY = 0.8;


/* =========================================================
   FCV OPENINGS
========================================================= */

const FCV2602_Opening =
  (valveData?.FCV_2602?.opening || 0) / 100;

const FCV2603_Opening =
  (valveData?.FCV_2603?.opening || 0) / 100;


/* =========================================================
   TOTAL OPENING
========================================================= */

const totalOpening110 =
  FCV2602_Opening +
  FCV2603_Opening;


/* =========================================================
   PUMP UTILIZATION
========================================================= */

const PumpUtilization110 =
  Math.min(totalOpening110, 1);


/* =========================================================
   AVAILABLE PUMP FLOW
========================================================= */

const PumpAvailableFlow110 =
  P110_Running
    ? P110_CAPACITY * PumpUtilization110
    : 0;


/* =========================================================
   TARGET FLOWS
========================================================= */

const targetFIC_2609 =
  totalOpening110 > 0
    ? PumpAvailableFlow110 *
      (FCV2602_Opening / totalOpening110)
    : 0;


const targetFIC_26010 =
  totalOpening110 > 0
    ? PumpAvailableFlow110 *
      (FCV2603_Opening / totalOpening110)
    : 0;


/* =========================================================
   FIC-2609 (TO T-101)
========================================================= */

const FIC_2609 = flowOverrides?.FIC_2609 ? 0 :
  (processData.FIC_2609 || 0);

useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_2609 || 0);

      const target =
        Number(targetFIC_2609 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_2609: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_2609]);

/* =========================================================
   FIC-18010 (TO T-104)
========================================================= */

const FIC_26010 = flowOverrides?.FIC_26010 ? 0 :
  (processData.FIC_26010 || 0);

useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_26010 || 0);

      const target =
        Number(targetFIC_26010 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_26010: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_26010]);


/* =========================================================
   TOTAL PUMP FLOW
========================================================= */

const InjectionWater =
  Number(
    (
      FIC_2609 +
      FIC_26010
    ).toFixed(3)
  );


/* =========================================================
   DISCHARGE PRESSURE
========================================================= */

const PT_2603 =
  P110_Running &&
  totalOpening110 > 0
    ? 0.85
    : 0.03;


/* =========================================================
   DISCHARGE TEMPERATURE
========================================================= */

const TT_2603 =
  P110_Running
    ? Number(TT_2601 || 25)
    : 25;





    const FIC_26012 = xv2604Open ? FIC_2601*0.00253 : 0;
    const PT_2604 =(PT_2601 * 0.93) + BackPressureFactor;
    const TT_2604 = xv2604Open ? TT_2601*0.987 : 26;
    
    const FIC_26013 = xv2605Open ? 3.0495 : 0;







useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_2605 === FIC_2605 &&
    current.FIC_2607 === FIC_2607 &&
    current.FIC_2608 === FIC_2608 &&
    current.FIC_2609 === FIC_2609 &&
    current.FIC_26010 === FIC_26010 &&
    current.FIC_26012 === FIC_26012 &&
    current.PT_2604 === PT_2604 &&
    current.FIC_2604 === FIC_2604 &&
    current.TT_2604 === TT_2604 &&
    current.TT_2602 === TT_2602 &&
    current.TT_2607 === TT_2607 &&
    current.PT_2607 === PT_2607
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_2605, FIC_2607, FIC_2608, FIC_2609, FIC_26010, FIC_26012, PT_2604, TT_2602, PT_2607, TT_2607, PT_2604, FIC_2604, TT_2604,  
    }
  });

}, [FIC_2605, FIC_2607, FIC_2608, FIC_2609, FIC_26010, FIC_26012, PT_2604, TT_2602, PT_2607, TT_2607, PT_2604, FIC_2604, TT_2604, ]);








  return (
    <div className="NaphthaReflux-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 303px",
          zIndex: 10,
        }}
      >
        T-104 NAPHTHA REFLUX SYSTEM
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2601 */}
      <Valve
        className="XV-2601"
        tag="XV_2601"
        x={1117}
        y={271}
        isClosed={valves.XV_2601}
        toggle={toggleValve}
      />

      {/* XV-2602 */}
      <Valve
        className="XV-2602"
        tag="XV_2602"
        x={1117}
        y={341}
        isClosed={valves.XV_2602}
        toggle={toggleValve}
      />

      {/* XV-2603 */}
      <Valve
        className="XV-2603"
        tag="XV_2603"
        x={592}
        y={327}
        isClosed={valves.XV_2603}
        toggle={toggleValve}
        r={90}
      />


      {/* XV-2604 */}
      <Valve
        className="XV-2604"
        tag="XV_2604"
        x={1165}
        y={87}
        isClosed={valves.XV_2604}
        toggle={toggleValve}
      />

      {/* XV-2605 */}
      <Valve
        className="XV-2605"
        tag="XV_2605"
        x={936}
        y={113}
        isClosed={valves.XV_2605}
        toggle={toggleValve}
      />


      <button
        onClick={() => setShowLab(true)}
        className="mds-btn"
        style={{
          position: "absolute",
          left: "1150px",
          top: "30px",
          zIndex: 500
        }}
        
      >
        LAB REPORT
      </button> 

      {showLab && (
        <LaboratoryAnalysisFaceplate
          close={() => setShowLab(false)}
        />
      )}




      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2601 */}
        <div
            style={{ position: "absolute", left: 967, top: 323, transform: "rotate(270deg)", transformOrigin: "center"}}
            onMouseEnter={() => setHoveredValve("FCV_2601")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2601")}
          >

            {hoveredValve === "FCV_2601" && (
              <div style={tagStyle}>
                FCV_2601
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2601">
                    
          <defs>
            <linearGradient id="metal_2601">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2601)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2601)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2602 */}
        <div
            style={{ position: "absolute", left: 290, top: 321}}
            onMouseEnter={() => setHoveredValve("FCV_2602")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2602")}
          >

            {hoveredValve === "FCV_2602" && (
              <div style={tagStyle}>
                FCV_2602
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2602">
                    
          <defs>
            <linearGradient id="metal_2602">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2602)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2602)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2603 */}
        <div
            style={{ position: "absolute", left: 290, top: 399}}
            onMouseEnter={() => setHoveredValve("FCV_2603")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2603")}
          >

            {hoveredValve === "FCV_2603" && (
              <div style={tagStyle}>
                FCV_2603
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2603">
                    
          <defs>
            <linearGradient id="metal_2603">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2603)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2603)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      



     
       

        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



 {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_2601?.opening || 0)}
        x={1042}
        y={342}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2602?.opening || 0)}
        x={312}
        y={365}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2603?.opening || 0)}
        x={312}
        y={443}
      />



        <Transmitter
          tag="TT_2601"
          value={[TT_2601]}
          x={212}
          y={63}
          unit="°C"
          max={100}
          HH={86}
          H={60}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CONDENSED OVERHEAD VAPOR AT THE TOP OF FRACTIONATION TOWER (T-102) TOV-102"
         />


         <Transmitter
          tag="PT_2601"
          value={[PT_2601]}
          x={352}
          y={63}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF CONDENSED OVERHEAD VAPOR AT THE TOP OF FRACTIONATION TOWER (T-101) TOV-102"
         />


         <Transmitter
          tag="FIC_2601"
          value={[FIC_2601]}
          x={492}
          y={63}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CONDENSED OVERHEAD VAPOR AT THE TOP OF FRACTIONATION TOWER (T-102) TO V-102"
         />

         <Transmitter
          tag="FIC_2606"
          value={[FIC_2606]}
          x={1042}
          y={523}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF NAPHTHA FROM P-104A/B"
         />

         <Transmitter
          tag="PT_2602"
          value={[PT_2602]}
          x={832}
          y={563}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF NAPHTHA FROM P-104A/B"
         />

         <Transmitter
          tag="TT_2602"
          value={[TT_2602]}
          x={962}
          y={590}
          unit="°C"
          max={100}
          HH={86}
          H={60}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF NAPHTHA FROM P-104A/B"
         />


         <Transmitter
          tag="FIC_2605"
          value={[FIC_2605]}
          x={1082}
          y={433}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF NAPHTHA REFLUX FROM P-104A/B TO T-102"
         />


         <Transmitter
          tag="FIC_2604"
          value={[FIC_2604]}
          x={882}
          y={333}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF NAPHTHA FROM P-104A/B TO V-301"
         />

         <Transmitter
          tag="FIC_2609"
          value={[FIC_2609]}
          x={162}
          y={313}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRODUCED WATER FOR WATER INJECTION TO T-102"
         />

         <Transmitter
          tag="FIC_26010"
          value={[FIC_26010]}
          x={162}
          y={393}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRODUCED WATER FOR WATER INJECTION AT SEWAGE WATER TREATMENT"
         />

         <Transmitter
          tag="FIC_26011"
          value={[FIC_26011]}
          x={502}
          y={333}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRODUCED WATER DRAINAGE FROM V-102 TO SUMP"
         />


         <Transmitter
          tag="PT_2603"
          value={[PT_2603]}
          x={362}
          y={563}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF PRODUCED WATER INJECTION FROM P-110"
         />

         <Transmitter
          tag="TT_2603"
          value={[TT_2603]}
          x={362}
          y={513}
          unit="°C"
          max={100}
          HH={86}
          H={60}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF PRODUCED WATER INJECTION FROM P-110"
         />

          <Transmitter
          tag="FIC_2607"
          value={[FIC_2607]}
          x={1172}
          y={233}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PREFLASHED NAPHTHA PRODUCED FROM P-104A/B TO V-301"
         />

          <Transmitter
          tag="FIC_2608"
          value={[FIC_2608]}
          x={1182}
          y={313}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PREFLASHED NAPHTHA PRODUCED FROM P-104A/B TO UNQUALIFIED LINE"
         />

          <Transmitter
          tag="FIC_26012"
          value={[FIC_26012]}
          x={822}
          y={73}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF NON CONDENSABLE LOW PRESSURE GASES FROM V-102 TO V-505"
         />


         <Transmitter
          tag="PT_2604"
          value={[PT_2604]}
          x={932}
          y={73}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF NON CONDENSABLE LOW PRESSURE GASES FROM V-102 TO V-505"
         />

         <Transmitter
          tag="TT_2604"
          value={[TT_2604]}
          x={1032}
          y={73}
          unit="°C"
          max={100}
          HH={86}
          H={60}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF NON CONDENSABLE LOW PRESSURE GASES FROM V-102 TO V-505"
         />







         
    <LevelTransmitterIndicator
      tag="LT_2601"
      totalLevel={500}
      inflows={[FIC_2601+FIC_26013]}
      outflows={[FIC_2606+FIC_26012]}
      inflowTags={["FIC_2601"]}
      outflowTags={["FIC_2606", "FIC_26012"]}
      responseFactor={0.05}
      columnX={559}
      columnY={172}
      columnWidth={306}
      columnHeight={121}
      textX={899}
      textY={182}
      showFlow={true}
      backgroundOpacity={0.00}
      liquidOpacity={0.6}
      service="naphtha"
    />

    <LevelTransmitterIndicator
      tag="LT_2602"
      totalLevel={500}
      inflows={[FIC_2601*0.09]}
      outflows={[FIC_2609+FIC_26010+FIC_26011]}
      inflowTags={["FIC_2601"]}
      outflowTags={["FIC_2609", "FIC_26010", "FIC_26011"]}
      responseFactor={0.05}
      columnX={559}
      columnY={172}
      columnWidth={306}
      columnHeight={121}
      textX={446}
      textY={182}
      showFlow={true}
      backgroundOpacity={0.00}
      liquidOpacity={0.4}
      service="water"
    />









            <Pump
              tag="P-104A"
              x={735}
              y={525}
              rpm={260}
              bladeCount={pumpData?.["P-104A"]?.bladeCount || 3}
              size={pumpData?.["P-104A"]?.size || 43}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-104B"
              x={735}
              y={608}
              rpm={260}
              bladeCount={pumpData?.["P-104B"]?.bladeCount || 3}
              size={pumpData?.["P-104B"]?.size || 43}
              onClick={openPumpPanel}
            />


            <Pump
              tag="P-110"
              x={504}
              y={572}
              rpm={260}
              bladeCount={pumpData?.["P-110"]?.bladeCount || 3}
              size={pumpData?.["P-110"]?.size || 43}
              onClick={openPumpPanel}
            />










       

    </div>
  );
}

export default NaphthaReflux;